import UserService from '../../services/UserService';
import UnauthorizedAlert from '../unauthorizedAlert/unauthorizedAlert';

const RoleRestricted = ({ role, children }) => {
	const hasRole = UserService.hasRole(role);
	return hasRole ? children : <UnauthorizedAlert/>;
}

export default RoleRestricted;